export enum ChatFirestorePaths {
    ROOMS = 'rooms',
    MESSAGES = 'messages',
}

export const CHAT_FIRESTORE_DATABASE_ID = 'chat';

/**
 * Quién escribió el mensaje. El valor es el que viaja en el documento de Firestore y lo
 * escriben los dos clientes (la torre y la app del chofer).
 */
export enum ChatMessageSenderTypes {
    OPERATOR = 'OPERATOR',
    DRIVER = 'DRIVER',
}
